import {ViewChild, ElementRef, Component, Input, Output, EventEmitter} from '@angular/core'
import { OnInit } from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {KeyValue} from '../../shared/key-value';

import {AuthorizationService} from '../../shared/authorization.service';

@Component({
  selector: 'app-decisions-submit-popup',
  templateUrl: './decisions-submit-popup.component.html',
  styleUrls: ['./decisions-submit-popup.component.css']
})
export class DecisionsSubmitPopupComponent{
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService, private KeyValueService: KeyValue) {

  }

  decisionStatusPage(){
    this.router.navigate([this.authService.getChangePath(KeyValue.decisionStatusPath)]);
  }
}
